prismanoteApp.controller('addToCartModalController', ['$scope', 'item',
  function ($scope, item) {
    $scope.item = item
  }
])
